// LocationDialogOption — Presentational single option button inside the
// location-selection dialog.
//
// Extracted VERBATIM from `components/RestaurantSearch.js` (behavior-preserving
// refactor, issue #240). Render-only, wrapped in React.memo. Markup, styles,
// and the onMouseOver/onMouseOut hover handlers are identical to the source.
//
// Validates: Requirements 3.3, 3.4, 1.2, 1.6

import React from 'react';
import { locationButtonStyle, blueHover, blueOut } from './styles';

export const LocationDialogOption = React.memo(function LocationDialogOption({ emoji, title, subtitle, onSelect }) {
  return (
    <button
      onClick={onSelect}
      style={locationButtonStyle}
      onMouseOver={blueHover}
      onMouseOut={blueOut}
    >
      <span style={{ fontSize: '24px' }}>{emoji}</span>
      <div>
        <div>{title}</div>
        <div style={{ fontSize: '14px', fontWeight: '400', opacity: 0.9 }}>
          {subtitle}
        </div>
      </div>
    </button>
  );
});

export default LocationDialogOption;
